import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, Cell } from 'recharts';

import { colorMappingData, rangeColorMapping } from './data';
import { ChartsHeader } from '../../components';
import { useStateContext } from '../../contexts/ContextProvider';

export const ColorMapping = () => {
  const { currentMode } = useStateContext();

  const data = colorMappingData && colorMappingData[0] ? colorMappingData[0] : [];

  const getColorForValue = (value: number | string | undefined): string => {
    const num = Number(value);
    if (Number.isNaN(num)) return '#8884d8';
    for (const range of rangeColorMapping) {
      const start = Number(range.start);
      const end = Number(range.end);
      if (!Number.isNaN(start) && !Number.isNaN(end) && num >= start && num <= end) {
        return String(Array.isArray(range.colors) ? range.colors[0] : '#8884d8');
      }
    }
    return '#8884d8';
  };

  return (
    <div className="m-4 md:m-10 mt-24 p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl">
      <ChartsHeader category="Mapeamento de Cores" title="CLIMA EUA - TEMPERATURA POR MÊS" />
      <div className="w-full" style={{ width: '100%', height: 360, background: currentMode === 'Dark' ? '#33373E' : '#fff', padding: 8, borderRadius: 6 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 20, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={currentMode === 'Dark' ? '#444' : '#e6e6e6'} />
            <XAxis dataKey="x" tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
            <YAxis tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
            <Tooltip contentStyle={{ backgroundColor: currentMode === 'Dark' ? '#1f2937' : '#fff', borderRadius: 6 }} />
            <Legend wrapperStyle={{ color: currentMode === 'Dark' ? '#eee' : '#333' }} />
            <Bar dataKey="y" radius={[10, 10, 0, 0]}>
              {data.map((entry: any, index: number) => {
                const rawValue: number | string | undefined = (entry && typeof entry === 'object' && 'y' in entry) ? (entry as any).y : (typeof entry === 'number' || typeof entry === 'string' ? entry : undefined);
                const color = getColorForValue(rawValue);
                return <Cell key={`cell-${index}`} fill={color} />;
              })}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
